export class Conjugationclass {
    public constructor(public conjguationNumber: number, public label: string, public content: string) {
    }
}
